<template>
  <div class="homehead">
    <div class="head">
      <div class="nianji">
        <van-dropdown-menu>
          <van-dropdown-item @change="tanchu" v-model="value1" :options="option1"/>
        </van-dropdown-menu>
      </div>
      <div class="search">
        <input type="text" placeholder="请输入搜索关键词" v-model="findtext">
        <van-icon @click="findval" name="search" class="icon icon-sousuo" size="0.5rem"/>
      </div>

      <div class="icon_icon" @click="icon">
        <svg class="icon icon_icon_icon" aria-hidden="true">
          <use xlink:href="#icontishi1"></use>
        </svg>
      </div>
      
    </div>
  </div>
</template>

<script>
import URL from '../api/index'
import Vue from 'vue';
import VueEvent from '../model/VueEvent'
import { Button, Icon,Notify,Toast } from 'vant';
Vue.use(Button);
Vue.use(Notify);
Vue.use(Icon);
Vue.use(Toast);
export default {
  // inject:['reload'],
  data(){
    return{
      flag:false,
      value1: 0,
      option1: [],
      selectval:'',
      findtext:'',
      word:'',
      grade_id:''
    }
  },
  beforeMount(){
    this.grade_id = JSON.parse(localStorage.getItem("grade_id"))
    if(this.grade_id == 0 || this.grade_id == null){
      this.tanchu(0)
    } else{
      this.value1 = this.grade_id
      this.tanchu(this.grade_id)
    }
  },
  mounted(){
    this.tanchu(this.value1)
  },
  methods:{
    findval(){//搜索
      VueEvent.$emit('word',this.findtext)
      Toast.success('搜索成功')
      this.findtext = ''
    },
    convertKey (arr, key) {
      let newArr = [];
      arr.forEach((item, index) => {
        let newObj = {};
        for (var i = 0; i < key.length; i++) {
          newObj[key[i]] = item[Object.keys(item)[i]]
        }
        newArr.push(newObj);
      })
      return newArr;
    },
    tanchu(val){
       VueEvent.$emit('grade',val)
      this.findtext = ""
      this.flag=!this.flag
      var that=this
      this.$axios({
        method:'post',    
        url:URL.get_grade_list
      }).then((res)=>{
        that.nianji = []
        that.nianji = that.nianji.concat({grade_id:0,gid: 0, grade_name: '全部'}).concat(res.data.result)
        that.option1=that.convertKey(that.nianji, ['grade_id','value', 'text'])
      })
      localStorage.setItem('grade_id',val)  
    },
    li(d){
      this.name= d
    },
    font(){
      Notify({ type: 'primary', message: '暂无结果',duration: 600,background: '#3682ff'});
    },
    icon(){
      Notify({ type: 'primary', message: '暂无消息',duration: 600 ,background: '#3682ff'});
    }
  }
}
</script>


<style scoped>  
@media screen and (min-width: 800px) {
  .head{
    width: 800PX;
    line-height: 1.2rem;
    text-align: center;
    display: flex;
    flex: 1;
    position: fixed;
    top: 0;
    z-index: 2;
    background-color: #fff;
  }
}
@media screen and (min-width: 320px) and (max-width: 799px) {
  .head{
    width: 100%;
    line-height: 1.2rem;
    text-align: center;
    display: flex;
    flex: 1;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    background-color: #fff;
  }
}

.nianji{
  flex: 0.2;
  font-size: 14px;
}
.nianji /deep/ .van-dropdown-menu__title{
  line-height: 50px;
}
.nianji /deep/ .van-dropdown-menu__title {
  padding: 0 8px 0 0;
  font-size: 14px;
}
.search{
  flex:0.70;
  position: relative;
  font-size: 0.32rem;
}
.search input{
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  border-radius: 0.32rem;
  text-indent: 1em;
  border: none;
  position: absolute;;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  box-shadow: 0px 0px 0.13333rem 0.08rem #f2f2f2 inset;
}
.search .icon-sousuo{
  position: absolute;
  right: 1%;
  top: 50%;
  transform: translate(-50%,-50%);
}

.icon_icon{
  line-height: 1.33333rem;
  flex: 0.1;
  position: relative;
  font-size: 16px;
}
.icon_icon_icon{
  position: absolute;;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/HomeHead.vue